require('./sctAdminNav.scss');

const sctAdminNav = angular.module('app.sct.sctAdminNav', []);

sctAdminNav.component('sctAdminNav', {
  controller: ['$rootScope', '$state', 'userFeedService', 'sctUserPermissionsService', controller],
  controllerAs: 'vm',
  template: require('./sctAdminNav.html')
});

function controller($rootScope, $state, userFeedService, sctUserPermissionsService) {
  let vm = this;
  vm.$state = $state;
  vm.userFeedService = userFeedService;
  vm.activities = [];
  vm.userPermission = sctUserPermissionsService.permissions;

  vm.toggle = toggle;

  $rootScope.$on('$stateChangeStart', stateChangeStart);

  function stateChangeStart() {
    vm.isActive = false;
  }

  function toggle() {
    vm.isActive = !vm.isActive;
  }
}

export default sctAdminNav;


// WEBPACK FOOTER //
// ./src/components/sct/sctAdmin/sctAdminNav/sctAdminNav.js